import { render, staticRenderFns } from "./SaleTagsAssignment.vue?vue&type=template&id=c92389c2&"
import script from "./SaleTagsAssignment.vue?vue&type=script&lang=js&"
export * from "./SaleTagsAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports